export default "__VITE_ASSET__3VS82rqX__"